import {
  FetchProfileFailure,
  FetchProfileRequest,
  FetchProfileSuccess,
  UpdatePasswordFailure,
  UpdatePasswordRequest,
  UpdatePasswordSuccess,
} from './profile.actions'
import { ShowSnackbar } from './../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as ProfileTypes from './profile.types'
import { map, switchMap, tap, catchError, mergeMap } from 'rxjs/operators'
import { ProfileService } from './profile.service'

@Injectable()
export class ProfileEffects {
  constructor(
    private actions: Actions,
    private profileService: ProfileService,
  ) {}

  FetchProfile$ = createEffect(() =>
    this.actions.pipe(
      ofType(ProfileTypes.FETCH_PROFILE_REQUEST),
      switchMap(() => {
        return this.profileService.fetchProfile().pipe(
          mergeMap(({ data }) => [new FetchProfileSuccess(data)]),
          catchError((err) => {
            return of(new FetchProfileFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdatePassword$ = createEffect(() =>
    this.actions.pipe(
      ofType(ProfileTypes.UPDATE_PASSWORD_REQUEST),
      switchMap((action: UpdatePasswordRequest) => {
        return this.profileService.updatePassword(action.payload).pipe(
          switchMap(() => {
            return [new UpdatePasswordSuccess()]
          }),
          catchError(() => {
            return of(new UpdatePasswordFailure({}))
          }),
        )
      }),
    ),
  )
}
